/**
 * 一些基础的公共函数
 */

function isObjectLike(value) {
  return typeof value === 'object' || value !== null;
}

function getTag(value) {
  return Object.prototype.toString.call(value);
}

export function isNull(value) {
  return value === null;
}

export function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (typeof value === 'string' || Array.isArray(value)) {
    return !value.length;
  }
  const tag = getTag(value);
  if (tag === '[object Map]' || tag === '[object Set]') {
    return !value.size;
  }

  const keys = Object.keys(value);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

export function isNumber(value) {
  return typeof value === 'number'
    || (isObjectLike(value) && getTag(value) === '[object Number]');
}

export function isString(value) {
  return typeof value === 'string' || getTag(value) === '[object String]';
}
/**
 * 为object {test:'test'}
 * @param  {[type]}  value [description]
 * @return {Boolean}       [description]
 */
export function isPlainObject(value) {
  if (!isObjectLike(value) || getTag(value) !== '[object Object]') {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  let proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

/**
 * 去掉尾部字符，不传默认为空格
 *
 */
export function trimEnd(str, char = ' ') {
  return str.replace(new RegExp(`\\${char}+$`, 'g'), '');
}
/**
 * 去掉前后空格
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
}

/**
 *
 */
export function unEscapseHtml(str) {
  if (!str) return '';
  const entities = {
    gt: '>',
    lt: '<',
    quot: '"',
    nbsp: ' ',
  };
  return str.replace(/&(lt|gt|nbsp|quot);/ig, (all, t) => entities[t]);
}

/**
 * 获取地址栏参数
 * @param name
 * @returns {*}
 */
export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

export function getCheckUaObject() {
  const nu = navigator.userAgent;
  return {
    ua: nu,
    ios: !!nu.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    ioshigh: /iphone os ([0-9]+)_/.exec(nu.toLowerCase()) ? /iphone os ([0-9]+)_/.exec(nu.toLowerCase())[1] : 0,
    android: nu.indexOf('Android') > -1 || nu.indexOf('Linux') > -1, // android终端或uc浏览器
    weixin: nu.indexOf('MicroMessenger') > -1,
    openharmony: nu.indexOf('OpenHarmony') > -1,
  };
}
/**
 * 拼接url和from码
 * @param targetUrl
 * @param fromSoj
 * @returns {string}
 */
export function concatSoj(targetUrl = 'https://m.anjuke.com/', fromSoj) {
  let url = targetUrl;
  if (fromSoj) {
    url = targetUrl.indexOf('?') > -1 ? `${targetUrl}&from=${fromSoj}` : `${targetUrl}?from=${
      fromSoj}`;
  }
  return url;
}

/**
 * 拼接url参数
 * @param {object} param
 */
export function concatUrlParams(params) {
  let result = '?';
  Object.keys(params).forEach((k) => {
    if (typeof params[k] === 'object') {
      result += (`${k}=${encodeURIComponent(JSON.stringify(params[k]))}&`);
    } else {
      result += (`${k}=${encodeURIComponent(params[k])}&`);
    }
  });

  result = result.substr(0, result.length - 1);
  return result;
}

/**
 *  防抖
 * @param {*} fn    要执行的函数
 * @param {*} time  间隔时间
 * @param {*} immediate 是否立即执行
 */
export function debounce(fn, time, immediate) {
  let timeout = null;
  return (args) => {
    clearTimeout(timeout);
    const context = this;
    if (!timeout && immediate) {
      fn.apply(context, args);
    }
    timeout = setTimeout(() => {
      if (!immediate) {
        fn.call(context, args);
      } else {
        timeout = null;
      }
    }, time);
  };
}

export function getCookie(sKey) {
  if (!sKey) {
    return null;
  }
  return decodeURIComponent(document.cookie.replace(new RegExp(`(?:^|.*;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*`), '$1'));
}
